import { motion } from "framer-motion";

export default function Card({
  title,
  icon: Icon,
  children,
  right,
  className = "",
  ...props
}) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 4 }}
      animate={{ opacity: 1, y: 0 }}
      whileTap={{ scale: 0.95 }}
      className={`rounded-2xl border border-zinc-800 bg-[#18181B] p-4 active:scale-95 transition-transform ${className}`}
      {...props}
    >
      {title && (
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2">
            {Icon && <Icon size={20} className="text-[#10B981]" />}
            <h2 className="font-bold text-white">{title}</h2>
          </div>
          {right}
        </div>
      )}
      {children}
    </motion.div>
  );
}
